// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'

import {getDistrictMap} from './getDistrictMap'

export function getDistrictByUrl(appState: ApplicationState, url: ?Url): ?District{
  return _getDistrictByUrl(appState.map, url) 
}

function _getDistrictByUrl(state: MapState, url: ?Url): ?District{
  if (!url) return null
  const districts: Map<District> = getDistrictMap.internal(state)
  return districts[url] 
}

getDistrictByUrl.internal = _getDistrictByUrl
